import cartesApi from '../../api/cartes-api';
import router from '../../router';

const cartes = {
  items: [],
  item: {},
  listSelect: [],
};

const mutations = {
  setItemsCartes (state, payload) {
    state.items = payload.data;
  },
  setItemCarte (state, payload) {
    state.item = payload;
  },
  setSelectCarte (state, payload) {
    state.listSelect = payload.data;
  },
};

const actions = {
  async refreshCartes (context, { language, restaurant_id }) {
    if (!restaurant_id) {
      restaurant_id = this.getters.getCurrentRestaurant;
    }
    context.commit('loading', true);
    const res = await cartesApi.getAllByRestaurant(restaurant_id, language);
    context.commit('loading', false);
    context.commit('setItemsCartes', res.data);
  },
  async getAllCartesPublicSimple (context, { restaurant_id, language }) {
    if (!restaurant_id) {
      restaurant_id = this.getters.getCurrentRestaurant;
    }
    const res = await cartesApi.getAllByRestaurantPublic(restaurant_id, language);
    context.commit('setItemsCartes', res);
  },
  async getCarte (context, { id, language }) {
    context.commit('setItemCarte', {});
    const res = await cartesApi.getOne(id, language);
    context.commit('setItemCarte', res.data.data);
  },
  async getCartePublic (context, { id, slug, language }) {
    const res = await cartesApi.getOnePublic(id, slug, language);
    context.commit('setItemCarte', res.data.data);
  },
  createCarte ({ commit }, { carte, language }) {
    commit('loading', true);
    cartesApi.create(carte, language).then(
      (response) => {
        commit('notifications', { title: 'Carta creada' });
        commit('loading', false);
        router.push({ name: 'cartes' });
        commit('showNotifications', true);
      },
      (error) => {
        let listMessages = [];
        Object.entries(error.response.data).forEach(([key, value]) => {
          value.forEach(
            item => {
              listMessages.push(item);
            });
         }
        );
        commit('loading', false);
        listMessages.forEach(message => {
          commit('notifications', { title: 'No ha sido posible crear la carta', text: message, color: 'danger' });
        })
        commit('showNotifications', true);
      },
    );
  },
  editCarte ({ commit, dispatch }, { id, carte, groups, language, newLanguage }) {
    commit('loading', true);

    if (groups) {
      for (let i = 0; i < groups.length; i++) {
        if (groups[i].id === 'NEW') {
          dispatch('createCarteGroup', { idCarte: id, group: groups[i], language });
        } else if (groups[i].id) {
          dispatch('editCarteGroup', { id: groups[i].id, group: groups[i], language });
        }
      }
    }

    cartesApi.edit(id, carte, language).then(
      (response) => {
        commit('notifications', { title: 'Carta editada' });
        if (newLanguage) {
          dispatch('getCarte', { id, language: newLanguage });
        }
        commit('loading', false);
        commit('showNotifications', true);
      },
      (error) => {
        let listMessages = [];
        Object.entries(error.response.data).forEach(([key, value]) => {
          value.forEach(
            item => {
              listMessages.push(item);
            });
         }
        );
        listMessages.forEach(message => {
          commit('notifications', { title: 'No ha sido posible editar la carta', text: message, color: 'danger' });
        });
        commit('loading', false);
        commit('showNotifications', true);
      },
    );
  },
  editCarteGroup ({ commit }, { id, group, language }) {
    cartesApi.editGroup(id, group, language);
  },
  createCarteGroup ({ commit }, { idCarte, group, language }) {
    cartesApi.createGroup(idCarte, group, language);
  },
  deleteCarte ({ commit, dispatch }, id) {
    commit('loading', true);
    cartesApi.delete(id).then(
      (response) => {
        dispatch('refreshCartes', {});
        commit('notifications', { title: 'Carta eliminada' });
        commit('loading', false);
        commit('showNotifications', true);
      },
      (error) => {
        commit('notifications', { title: 'No ha sido posible eliminar la carta', color: 'danger' });
        commit('loading', false);
        commit('showNotifications', true);
      },
    );
  },
  deleteCarteGroup ({ commit }, idGroup) {
    commit('loading', true);
    cartesApi.deleteGroup(idGroup).then(
      (response) => {
        commit('notifications', { title: 'Grupo eliminado' });
        commit('loading', false);
        commit('showNotifications', true);
      },
      (error) => {
        commit('notifications', { title: 'No ha sido posible eliminar el grupo', color: 'danger' });
        commit('loading', false);
        commit('showNotifications', true);
      },
    );
  },
  activeCarte ({ commit, dispatch }, id) {
    commit('loading', true);
    cartesApi.active(id).then(
      (response) => {
        dispatch('refreshCartes', {});
        commit('notifications', { title: 'Carta activada' });
        commit('loading', false);
        commit('showNotifications', true);
      },
      (error) => {
        commit('notifications', { title: 'No ha sido posible activar la carta', color: 'danger' });
        commit('loading', false);
        commit('showNotifications', true);
      },
    );
  },
  deactiveCarte ({ commit, dispatch }, id) {
    commit('loading', true);
    cartesApi.deactive(id).then(
      (response) => {
        dispatch('refreshCartes', {});
        commit('notifications', { title: 'Carta desactivada' });
        commit('loading', false);
        commit('showNotifications', true);
      },
      (error) => {
        commit('notifications', { title: 'No ha sido posible desactivar la carta', color: 'danger' });
        commit('loading', false);
        commit('showNotifications', true);
      },
    );
  },
};

const getters = {
  getCartes: (state) => state.items,
  getCarte: (state) => state.item,
  cartesListSelect: (state) => state.listSelect,
};

export default {
  state: cartes,
  mutations,
  actions,
  getters,
};
